import * as types from '../actions/types';

const initialState = {
  data: {},
  isError: false
};

const validateSelectingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.VALIDATE_SELECTING_REQUESTED:
      return {
        ...state,
        error: null
      };
    case types.VALIDATE_SELECTING_SUCCEEDED:
      return {
        ...state,
        data: action.data.data,
        error: null,
        isError: false
      };
    case types.VALIDATE_SELECTING_FAILED:
      return {
        ...state,
        isError: true,
        data: null,
        error: action.error
      };
    default:
      return state;
  }
};

export default validateSelectingReducer;
